module.exports = __webpack_public_path__ + "img/buddy_eyes-03.6c6647c1.svg";